// @flow

import { combineReducers } from 'redux';
import viewer from './viewer';
import model from './model';
import segmentation from './segmentation';

export default combineReducers({
  viewer,
  model,
  segmentation,
});
